import type { UserTask } from "@/types/userTasks.ts";

/**
 * What a parked row says under its title: the day it comes back, and in
 * which spirit it was put down.
 *
 * A commitment is the reader's promise, so the line says what they said:
 * "To complete by Thursday". A snooze is a postponement and says only that it
 * is out of the way until then. The two write the same status and date; the
 * mark is the one thing that tells them apart, and the row is where the
 * reader would otherwise mistake one for the other.
 *
 * Shared because both platforms draw the line and the words must not drift.
 * `locale` is for tests; the apps leave it to the device, as `dueLine` does.
 */
export function snoozedLine(
  task: Pick<UserTask, "status" | "snoozedUntilMs" | "committedAtMs">,
  locale?: string,
) {
  if (task.status !== "later" || !task.snoozedUntilMs) return null;
  const day = new Date(task.snoozedUntilMs).toLocaleDateString(locale, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
  return task.committedAtMs ? `To complete by ${day}` : `Snoozed until ${day}`;
}
